'use client';
import { useReadShinkaiTokenBalanceOf } from '../generated';
import { getShinkaiTokenAddress } from '../contracts';
import { useEvmWallet } from './useEvmWallet';

export const useGetUserKaiTokenBalance = () => {
  const { address } = useEvmWallet();
  return useReadShinkaiTokenBalanceOf({
    address: getShinkaiTokenAddress(),
    args: [address!],
    query: {
      enabled: address !== undefined,
      staleTime: 60000,
    },
  });
};
